import { Auth0Provider, AppState } from '@auth0/auth0-react';
import React, { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';

interface Auth0ProviderWithNavigateProps {
  children: React.ReactNode;
}

export const Auth0ProviderWithNavigate = ({
  children,
}: PropsWithChildren<Auth0ProviderWithNavigateProps>): JSX.Element | null => {
  const navigate = useNavigate();

  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const redirectUri = window.location.origin + "/details";
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

  const onRedirectCallback = (appState?: AppState) => {
    // Check if this is an invite flow
    const urlParams = new URLSearchParams(window.location.search);
    const invite_id = urlParams.get('invite_id');
    const org_id = urlParams.get('org_id');

    if (invite_id && org_id) {
      // This is an invite flow, redirect to details-buyer
      navigate(`/details-buyer?invite_id=${invite_id}&org_id=${org_id}`);
    } else if (appState?.returnTo) {
      // Check if returnTo is a storefront URL (from org_id parameter)
      if (appState.returnTo.startsWith('/storefront/')) {
        navigate(appState.returnTo);
      } else {
        // Regular flow, use appState or current path
        navigate(appState.returnTo || window.location.pathname);
      }
    } else {
      // Regular flow, use current path
      navigate(window.location.pathname);
    }
  };

  if (!(domain && clientId && redirectUri)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      audience={audience}
      redirectUri={redirectUri}
      useRefreshTokens={true}
      cacheLocation="localstorage"
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};
